/**
 * Two letters, so a brand or a person with no picture still gets a stable mark.
 *
 * The mark is what the eye lands on in a collapsed rail, where there is no room
 * for a name — and it is the only thing distinguishing two accounts a person
 * belongs to. Deriving it rather than storing it means a rename moves it.
 */
export function initials(name: string): string {
	const words = name.trim().split(/\s+/).filter(Boolean);
	if (words.length === 0) return "??";
	if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
	return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}
